/**
 * English - `tipsAccount`: the ⓘ explanations beside team, permission and
 * password fields. One key per field, `<form>.<field>`, passed as the field's
 * `info`.
 * Conventions: see `common.ts`.
 */
const tipsAccount: Record<string, string> = {
  // >>> team member (invite and edit)
  'member.full_name':
    'The name of this team member as it appears across the dashboard. Use 2 to 120 characters. Example: Priya Sharma',
  'member.phone':
    'A contact number for this team member, so you can reach them quickly. Optional. Example: +91 98765 43210',
  'member.work_email':
    'The email address this person signs in with. With an invitation, the link to set their password is sent here. It cannot be changed later. Example: priya@kurtaandco.in',
  'member.role':
    'A ready-made set of permissions that decides what this person can see and do. Pick the closest role; you can then customise individual permissions below if needed.',
  'member.password':
    'An opening password for this person, which you share with them yourself. They must change it the first time they sign in. Use Generate for a strong one. At least 10 characters.',

  // >>> permissions
  'permissions.customise':
    'When ticked, this member keeps exactly the permissions you tick below, even if their role changes later. When not ticked, they simply get everything their role allows.',

  // >>> change password
  'password.current_password':
    'The password you use to sign in today. We ask for it to confirm it is really you making this change.',
  'password.given_password':
    'The temporary password someone on your team gave you to sign in with. We ask for it once to confirm it is really you.',
  'password.new_password':
    'The password you will sign in with from now on. Use 10 to 128 characters, not only numbers, with at least 5 different characters. A short phrase is easy to remember and hard to guess.',
  'password.confirm_password':
    'Type the new password again, exactly the same, to make sure there is no typo.',

  // >>> my account
  'account.full_name':
    'Your name as your team sees it across the dashboard and in the activity log. Use 2 to 120 characters. Example: Priya Sharma',
  'account.phone':
    'A number your team or the platform can reach you on. Optional, and not shown to customers. Example: +91 98765 43210',
  'account.new_email':
    'The address you will sign in with from now on. We send a code to it, and you must enter that code before you next sign in. Example: priya@kurtaandco.in',
  'account.code':
    'The 6-digit code in the email we just sent to your new address. It expires after a few minutes; ask for a new one if it has.',
  'account.language':
    'The language the dashboard is shown in for you. It does not change your storefront or what your team sees.',

  // >>> QA phase 5 additions
  'member.role_filter': 'Show only the people with this role.',
};

export default tipsAccount;
